let memoizedUrl = null;
export const getGraphqlUrlFromEnv = () => {
    const isTest = process.env.NODE_ENV === 'test';
    const isMocking = process.env.MOCKING_ENABLED === 'true';
    // 1. MSW / Testing Strategy
    if (isTest || isMocking) {
        return 'http://example.com/graphql';
    }
    // 2. Client-side Strategy (Relative Path for Next.js Proxy)
    if (typeof window !== 'undefined') {
        return '/graphql';
    }
    // 3. Memoized Server-side Strategy
    if (memoizedUrl)
        return memoizedUrl;
    const { GRAPHQL_NAMESPACE, SERVER_GRAPHQL_URL } = process.env;
    if (GRAPHQL_NAMESPACE) {
        memoizedUrl = `http://dt-gql-gateway-api.${GRAPHQL_NAMESPACE}/graphql`;
    }
    else if (SERVER_GRAPHQL_URL) {
        memoizedUrl = SERVER_GRAPHQL_URL;
    }
    else {
        memoizedUrl = 'http://localhost:4000';
    }
    console.log(`Setting GraphQL URL to: ${memoizedUrl}`);
    return memoizedUrl;
};
